import script from "./Material.vue?vue&type=script&setup=true&lang=js"
export * from "./Material.vue?vue&type=script&setup=true&lang=js"

import "./Material.vue?vue&type=style&index=0&id=49d56e9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49d56e9e"]])

export default __exports__